import * as React from 'react';
import Text from 'components/Text';
import Link from 'components/Link';
import AsyncSelectItem from 'components/AsyncSelectItem';

export default function OrganizationPickerNewItem() {
  return (
    <AsyncSelectItem title="">
      <Text>
        Can’t find your organization? <Link weight="semibold">Add it now</Link>
      </Text>
    </AsyncSelectItem>
  );
}
